import { useTranslation } from "react-i18next";

import { cn } from "utils/cn";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "components/AlertDialog";

import { ReactComponent as PriorityHigh } from "assets/priority_high.svg";

import type { CancelSessionDialogProps } from "./CancelSessionDialog.types";
import { useCancelSessionDialog } from "./useCancelSessionDialog";

export default function CancelSessionDialog({ open, setOpen, cancelSession }: CancelSessionDialogProps) {
  const { t } = useTranslation();

  const { handleConfirm } = useCancelSessionDialog({ cancelSession });

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div
            className={cn(
              "w-20 h-20 m-auto mb-5  rounded-full flex items-center justify-center bg-general-orange-700 border border-general-orange-800",
            )}
          >
            <PriorityHigh className="w-16 h-16 fill-general-orange-900" />
          </div>
          <AlertDialogTitle className="text-center">{t("session.cancelSessionDialog.title")}</AlertDialogTitle>
          <AlertDialogDescription className="text-center">
            {t("session.cancelSessionDialog.description")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="w-full md:flex-1">{t("button.continue")}</AlertDialogCancel>
          <AlertDialogAction className="w-full md:flex-1" onClick={handleConfirm}>
            {t("button.cancelSession")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
